import { AnalysisUseCase } from 'generated/graphql';

export const getAnalysisTypeDisplayName = (
  analysisUseCase: AnalysisUseCase | undefined,
) => {
  switch (analysisUseCase) {
    case AnalysisUseCase.Feed:
      return 'Feed';
    case AnalysisUseCase.Collection:
      return 'Collection';
    default:
      return 'Quantify';
  }
};
